import { render, staticRenderFns } from "./IncomeGrowth.vue?vue&type=template&id=242a9d36&scoped=true&"
import script from "./IncomeGrowth.vue?vue&type=script&lang=js&"
export * from "./IncomeGrowth.vue?vue&type=script&lang=js&"
import style0 from "./IncomeGrowth.vue?vue&type=style&index=0&id=242a9d36&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242a9d36",
  null
  
)

export default component.exports